import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import {
  competitionAverageSelectedCompetitionsAtom,
  competitionAverageSelectedSeasonsAtom,
} from '@/atoms/filters/team/teamCompetitionAverageFilters';
import { BioTableContent } from '@/components/radar/table/RadarBioTable';

// returns the comparison bio column for competition-average mode
export const useTeamCompetitionAverageBioColumn = () => {
  const { t } = useTranslation(['radar', 'filters']);
  const selectedCompetitions = useAtomValue(competitionAverageSelectedCompetitionsAtom);
  const selectedSeasons = useAtomValue(competitionAverageSelectedSeasonsAtom);

  return {
    name: t('competitionAverage.optionLabel', { ns: 'radar' }),
    competition: <BioTableContent options={selectedCompetitions} />,
    season: <BioTableContent options={selectedSeasons} />,
    game: t('allGames', { ns: 'filters' }),
  };
};
